import { Tooltip } from "@chakra-ui/react";

const EditCompanyIcon = (props: any) => (
    <Tooltip label={props.label ?? 'Edit Company'} aria-label={props.label ?? 'Edit Company Tooltip'}>
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={props.label ?? 'Edit Company'}
            {...props}
        >
            <path
                d="M13.5 6.49982L17.5 10.4998M16 18.9998H22M4 19.9998H8L18.5 9.49981C18.7626 9.23717 18.971 8.92537 19.1131 8.58221C19.2553 8.23905 19.3284 7.87125 19.3284 7.49981C19.3284 7.12838 19.2553 6.76058 19.1131 6.41742C18.971 6.07426 18.7626 5.76246 18.5 5.49981C18.2374 5.23717 17.9256 5.02883 17.5824 4.88669C17.2392 4.74455 16.8714 4.67139 16.5 4.67139C16.1286 4.67139 15.7608 4.74455 15.4176 4.88669C15.0744 5.02883 14.7626 5.23717 14.5 5.49981L4 15.9998V19.9998Z"
                stroke="magenta"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </Tooltip>
);

export default EditCompanyIcon;
